function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { once } from '@sail/utils';
import { AlreadyInitializedObservabilityError, UninitializedObservabilityError } from '../../internal/common/errors';
import logErrorInDev from '../../internal/common/logErrorInDev';
const logUninitializedObservabilityErrorOnce = once(()=>{
    logErrorInDev(new UninitializedObservabilityError());
});
const logAlreadyInitializedObservabilityErrorOnce = once(()=>{
    logErrorInDev(new AlreadyInitializedObservabilityError());
});
// TODO(endrit): Report error to sentry & signalfx instead of logging.
// This will be possible when we add RPC support, to avoid reporting
// internal @sail/observability errors in main window.
class Config {
    getAll() {
        if (!this._isInitialized) {
            logUninitializedObservabilityErrorOnce();
        }
        return this.store;
    }
    get(key) {
        if (!this._isInitialized) {
            logUninitializedObservabilityErrorOnce();
        }
        return this.store[key];
    }
    set(store) {
        if (this._isInitialized) {
            logAlreadyInitializedObservabilityErrorOnce();
            return false;
        }
        this.store = Object.freeze(store);
        this._isInitialized = true;
        return true;
    }
    isInitialized() {
        return this._isInitialized;
    }
    constructor(initialValue){
        _define_property(this, "_isInitialized", false);
        _define_property(this, "store", void 0);
        this.store = initialValue;
    }
}
export default Config;

//# sourceMappingURL=config.js.map